/**
 * Used to commit and track state changes
 * Mutations should always execute sync operations.
 */
const setSlidesInterval = (state, seconds) => {
  state.slidesIntervalInSeconds = seconds;
};

const setWallboardFontSize = (state, fontSize) => {
  state.fontSize = fontSize;
};

const setWallboardCards = (state, cards) => {
  state.cards = cards;
};

const setWallboardTheme = (state, theme) => {
  state.theme = theme;
};

const setWallboardStatistics = (state, statistics) => {
  state.allWallboardStatistics = statistics;
};

const setWallboardName = (state, name) => {
  state.name = name;
};

export default {
  setWallboardFontSize,
  setSlidesInterval,
  setWallboardCards,
  setWallboardTheme,
  setWallboardStatistics,
  setWallboardName
};
